export const FIND_ADDON_ASSIGNMENTS = `
  query FindAddonAssignments($addonId: String!) {
    addon {
      findAddonAssignments(addonId: $addonId) {
        products
        media
        routines
      }
    }
  }
`;
